
import axios from 'axios'

export default {
    getFaceGroupList({commit}, params){
        return axios.post('/api/facepay/shop/face/group/role/list/', params)
    },
    addFaceGroup({commit}, params){
        return axios.post('/api/facepay/shop/face/group/role/add/', params)
    },
    modifyFaceGroup({commit}, params){
        return axios.post('/api/facepay/shop/face/group/role/modify/', params)
    },
    deleteFaceGroup({commit}, params){
        return axios.post('/api/facepay/shop/face/group/role/delete/', params)
    },
    getFaceUserList({commit}, params){
        return axios.post('/api/facepay/shop/face/user/list/', params)
    },
    getFaceUserInfo({commit}, params){
        return axios.post('/api/facepay/shop/face/user/info/get/', params)
    },
    modifyUserFaceGroup({commit}, params){
        return axios.post('/api/facepay/shop/face/user/group/modify', params)
    },
    deleteFaceUser({commit}, params){
        return axios.post('/api/facepay/shop/face/user/status/delete', params)
    },
    getFeceUserAcountList({commit}, params){
        return axios.post('/api/facepay/shop/face/user/info/list/', params)
    },
    modifyFaceUserAccountStatus({commit}, params){
        return axios.post('/api/facepay/shop/face/user/status/modify', params)
    },
    refundFaceAccount({commit}, params){
        return axios.post('/api/facepay/shop/face/user/refund', params)
    },
    
}


// WEBPACK FOOTER //
// ./src/vuex/actions/face.js